// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._mekaalBQZt9psr7y62z {\n\tflex-shrink: 0;\n\twidth: 100%;\n\tz-index: 100;\n}\n", "",{"version":3,"sources":["webpack://./src/components/Header/Header.pcss"],"names":[],"mappings":"AAAA;CACC,cAAc;CACd,WAAW;CACX,YAAY;AACb","sourcesContent":[".header {\n\tflex-shrink: 0;\n\twidth: 100%;\n\tz-index: 100;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": "_mekaalBQZt9psr7y62z"
};
export default ___CSS_LOADER_EXPORT___;
